'use client'

export default function Home() {
  return <></>
}
